import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=f6dec8da&scoped=true&"
import script from "./VideoWrapper.vue?vue&type=script&lang=js&"
export * from "./VideoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./VideoWrapper.vue?vue&type=style&index=0&id=f6dec8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dec8da",
  null
  
)

export default component.exports